<template>
    <div>
        <app-sub-title text="Filtros" />
        <b-card>
            <div class="card-text">
                <b-row>
                    <b-col cols="12" md="4" lg="3">
                            <b-form-input
                                placeholder="Nombre del archivo"
                                type="text"
                                size="sm"
                                id="title"
                                v-model="filters.fileName"
                            ></b-form-input>
                    </b-col>
                    <b-col cols="12" md="2" lg="1">
                        <b-button variant="primary" class="btn-block" @click="$emit('filter', filters)"><i class="fa fa-filter"></i></b-button>
                    </b-col>
                    <b-col cols="12" md="2" lg="1">
                        <b-button variant="secondary" class="btn-block" @click="clearFilters"><i class="fa fa-times-circle"></i></b-button>
                    </b-col>
                </b-row>
            </div>
        </b-card>
    </div>
</template>
<script>
export default {
    data(){
        return {
            filters: {
                fileName: ''
            },
        }
    },
    methods: {
        clearFilters(){
            this.selectUser = '';
            Object.keys(this.filters).map(key => this.filters[key] = '');
            this.$emit('filter', null);
        }
    }
}
</script>